;
/*!
 * SubitoTexto.loadMorePosts.js
 */
SubitoTexto.loadMorePosts = {
	init                       : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		if ( typeof CONFIG == 'undefined' || CONFIG.load_more_posts_url == 'undefined' ) {
			console.error( '[SubitoTexto.loadMorePosts] Need the URL to load more' );
			return;
		}

		// Detecting presence / need with this selector
		_this.$moreArticlesContainer = $( '.more-articles' );
		if ( _this.$moreArticlesContainer.length < 1 ) {
			// Nothing to do on this page
			return;
		}


		// JSON object passed by the blogposts-archive.php page
		if ( typeof window.blogPosts != 'undefined' ) {
			_this.blogPosts = blogPosts;
		} else {
			_this.blogPosts = {};
		}

		_this.$authorsFilter = $( '.authors-filter' );
		_this.$btnFilterToggler = $( '.author-filter-toggler' );


		// Moving on with vars and initial methods
		_this.$originalPostContainers = $( '[class*=blog-archive-row-]' );
		_this.$originalPosts = _this.$originalPostContainers.find( '.entry' );
		_this.$btnLoadMore = $( '.btn-load-more' );
		_this.hasMorePosts = _this.$moreArticlesContainer.data( 'has-more-posts' );
		_this.iNumColourSchemes = 4;
		_this.iLastColourScheme = _this.$moreArticlesContainer.data( 'last-colour-scheme' );
		_this.hasMorePostsBtnActive = true;

		_this.currPage = 1;
		_this.currAuthorFilter = false;
		_this.numPostsOnInitialPage = _this.$originalPosts.length;
		_this.postsPerPage = 12;


		// No use in setting everything up if there aren't any more posts
		if ( _this.hasMorePosts == false ) {
			_this.deactivateMoreFunctionality();
			return;
		}


		_this.bindEvents();


	},
	bindEvents                 : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		_this.activateMoreFunctionality();

		_this.$btnFilterToggler.on( 'click', function ( e ) {

			if ( _this.currAuthorFilter != 0 ) {
				// Don't let them close it if one is active
				return false;
			}

			if ( _this.$authorsFilter.hasClass( 'open' ) ) {
				_this.closeAuthorsFilter();
			} else {
				_this.openAuthorsFilter();
			}
		} );


		_this.$authorsFilter.on( 'click', '.author', function ( e ) {
			e.preventDefault();

			var $this = $( this ),
				authorId = $this.data( 'author-id' );

			_this.$authorsFilter.find( '.author' ).removeClass( 'active' );

			if ( authorId && authorId > 0 ) {
				_this.currPage = 0;
				_this.currAuthorFilter = authorId;
				_this.ajaxGetMorePosts( true );
				_this.$authorsFilter.addClass( 'author-filter-active' );
				$this.addClass( 'active' );
			} else {
				_this.currPage = 0;
				_this.currAuthorFilter = 0;
				_this.ajaxGetMorePosts( true );
				_this.$authorsFilter.removeClass( 'author-filter-active' );
				_this.closeAuthorsFilter();
			}

		} );


	},
	activateMoreFunctionality  : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		_this.$btnLoadMore.show();
		_this.$btnLoadMore.on( 'click.btnLoadMore', function ( e ) {
			_this.ajaxGetMorePosts();
		} );

		_this.hasMorePostsBtnActive = true;

	},
	deactivateMoreFunctionality: function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		_this.$btnLoadMore.off( 'click.btnLoadMore' );

		_this.$btnLoadMore.hide();

		_this.hasMorePostsBtnActive = false;


	},

	appendReplacePosts: function ( arrPosts, doReplace ) {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		var numPosts = arrPosts.length

		if ( numPosts < 1 ) {
			// weird... we should have at least one to work with
			return;
		}

		_this.$moreArticlesContainer.attr( 'aria-busy', true );

		if ( typeof doReplace == 'undefined' || doReplace == false ) {
			// we're appending


			var htmlToAppend = '';

			var counter = 0;
			var rowAlignment = 'left';


			$.each( arrPosts, function ( i, blogPost ) {
				// open the container before every 3
				if ( i == 0 || counter % 3 == 0 ) {
					htmlToAppend += '<div class="post-listings-container blog-archive-row-' + rowAlignment + '">';
				}
				htmlToAppend += _this.postTemplate( blogPost );

				// close the container after every three or after the last one
				if ( counter % 3 == 2 || ( counter + 1 == numPosts) ) {
					htmlToAppend += '</div>';
					rowAlignment = rowAlignment == 'left' ? 'right' : 'left';
				}

				_this.iLastColourScheme = blogPost.iColourScheme;
				counter++;
			} );

			var $appended = $( htmlToAppend ).appendTo( _this.$moreArticlesContainer );
			return $appended.find( '.entry' );

		} else {
			// we're replacing

			//console.log( 'About to replace posts with those of ', _this.currAuthorFilter );

			// Empty out the "more posts" container
			_this.$moreArticlesContainer.html( '' );

			// hide the original post positions we don't need
			_this.$originalPosts.removeClass( 'hidden replacing' );
			_this.$originalPostContainers.show();


			_this.$originalPosts.slice( numPosts ).addClass( 'hidden' );

			_this.iLastColourScheme = 0;
			_this.$originalPosts.slice( 0, numPosts ).each( function ( i, el ) {
				$( this ).replaceWith( _this.postTemplate( arrPosts[ i ] ) );
				_this.iLastColourScheme++;
			} );

			// updating our original posts because .replace... replaces ;)
			_this.$originalPosts = _this.$originalPostContainers.find( '.entry' );


			// Hide the containers that have nothing left to show
			_this.$originalPostContainers.each( function ( i, el ) {
				var $this = $( this ),
					containsNePasToucher = $this.find( '.ne-pas-toucher-btn' ).length > 0,
					containsUnhiddenPosts = $this.find( '.entry' ).not( '.hidden' ).length > 0;

				if ( /* !containsNePasToucher && */ !containsUnhiddenPosts ) {
					$this.hide();
				}
			} );


			return _this.$originalPosts.slice( 0, numPosts );
		}

	},
	ajaxGetMorePosts  : function ( doReplace ) {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		var dataRequest = {
			action           : "load_more_posts",
			firstPagePostsNum: _this.numPostsOnInitialPage,
			currPage         : _this.currPage,
			currAuthor       : _this.currAuthorFilter,
			postsPerPage     : _this.postsPerPage,
			isAppending      : typeof doReplace == 'undefined' || doReplace == false,
			lastColourScheme : _this.iLastColourScheme
		};

		$.ajax( {
			url     : CONFIG.load_more_posts_url,
			data    : dataRequest,
			dataType: 'json',
			type    : 'post',
		} )
			.done( function ( _data ) {


				if ( typeof _data.success != 'undefined' && _data.success == 1
					&& typeof _data.data != 'undefined'
					&& typeof  _data.data.posts != 'undefined' && _data.data.posts.length > 0 ) {


					var $affected = _this.appendReplacePosts( _data.data.posts, doReplace );
					_this.currPage = _data.data.iNewCurrPage;
					_this.hasMorePosts = _data.data.isLastPage != true;

					_this.$moreArticlesContainer.removeAttr( 'aria-busy' );


					if ( !_this.hasMorePosts ) {
						_this.deactivateMoreFunctionality();
					} else {

						// No use in re-binding if it's already bind'ed
						if ( !_this.hasMorePostsBtnActive ) {
							_this.activateMoreFunctionality();
						}
					}


					var $firstPostLink = $affected.eq( 0 ).find( '.post-link' );

					if ( $firstPostLink.length > 0 ) {
						PLA.UTILS.scrollTop.scrollTo( $firstPostLink, ( -10 - _this.$authorsFilter.outerHeight()) );
						$firstPostLink.focus();
					}


				} else {
					console.table( _data.errors );
				}
			} );


	},


	postTemplate: function ( blogPost ) {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		var colourSchemeClass = 'type_' + ( ( _this.iLastColourScheme % _this.iNumColourSchemes) + 1 ),
			classLongAuthorName = "";

		if ( blogPost.authorName.length > 7 ) {
			classLongAuthorName = ' long-author-name ';
		}

		return '<article data-id="' + blogPost.id + '" class="entry ' + colourSchemeClass + '" role="article" itemscope itemtype="http://schema.org/BlogPosting">' +
			'<time itemprop="datePublished" datetime="' + blogPost.datetimeIso + '"></time>' +
			'<a class="post-link" href="' + blogPost.permalink + '">' +
			'<div class="post-thumbnail-container" style=" background-image: url(' + blogPost.thumbnail + '); ">' +
			'<meta content="' + blogPost.thumbnail + '" itemprop="image" />' +
			'</div>' +
			'<div class="entry-meta">' +
			'<h2 class="post-title"  itemprop="headline">' + blogPost.title + '</h2>' +
			'<div class="post-author' + classLongAuthorName + '" itemprop="author" itemscope="" itemtype="http://schema.org/Person"><span class="author-by">par</span> <span itemprop="name">' + blogPost.authorName + '</span></div>' +
			'<span class="sr-only">Lire l\'article </span>' +
			'</div>' +
			'</a>' +
			'</article>';
	},


	openAuthorsFilter : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		_this.$authorsFilter.addClass( 'open' );
		_this.$authorsFilter.find( 'a' ).attr( 'tabindex', '0' );
		_this.$btnFilterToggler.addClass( 'active' );

		_this.$authorsFilter.find( 'a' ).eq( 0 ).focus();


	},
	closeAuthorsFilter: function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMorePosts;

		_this.$authorsFilter.removeClass( 'open' );
		_this.$authorsFilter.find( 'a' ).attr( 'tabindex', '-1' );
		_this.$btnFilterToggler.removeClass( 'active' );
	}


};
